'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';
import dynamic from 'next/dynamic';

const AccessibilityToolbar = dynamic(() => import('@/components/accessibility/AccessibilityToolbar'), { ssr: false });
const ReadingGuide = dynamic(() => import('@/components/accessibility/ReadingGuide'), { ssr: false });
const SkipLinks = dynamic(
  () => import('@/components/accessibility/SkipLinks').then((m) => ({ default: m.SkipLinks })),
  { ssr: false }
);
const VLibrasWidget = dynamic(() => import('@/components/VLibrasWidget'), { ssr: false });
const CookieConsentBanner = dynamic(
  () => import('@/components/CookieConsentBanner').then((m) => ({ default: m.CookieConsentBanner })),
  { ssr: false }
);
const Toaster = dynamic(() => import('@/components/ui/toaster').then((m) => ({ default: m.Toaster })), { ssr: false });
const ErrorToastDebugger = dynamic(
  () => import('@/components/debug/ErrorToastDebugger').then((m) => ({ default: m.ErrorToastDebugger })),
  { ssr: false }
);

export default function DeferredExtras({ lng }: { lng: string }) {
  const { acessibilidadeBilheteria } = useFlags();

  return (
    <>
      {acessibilidadeBilheteria && (
        <>
          <SkipLinks />
          <AccessibilityToolbar />
          <ReadingGuide />
          <VLibrasWidget />
        </>
      )}
      <CookieConsentBanner />
      <Toaster />
      {process.env.NODE_ENV === 'development' && <ErrorToastDebugger lng={lng} />}
    </>
  );
}
